import useTranslation from "next-translate/useTranslation";
import { useMemo } from "react";
import {
  PROFILE_ACCOUNT_ROUTE,
  PROFILE_SETTINGS_ROUTE,
  PROFILE_FOLLOWING_ROUTE,
  PROFILE_BOOKMARKS_ROUTE,
  PROFILE_PURCHASES_ROUTE,
} from "@/constants/routes.constant";
import type { Tab } from "@motain/xpa-proto-files-web/lib/types/tabs";

export function useProfileTabs(activeTabName: string): ReadonlyArray<Tab> {
  const { t } = useTranslation("web-payments");

  return useMemo(() => {
    const tabs: Array<Tab> = [
      {
        name: t`FOLLOWING`,
        urlPath: PROFILE_FOLLOWING_ROUTE,
        isActive: false,
        uiKey: t`FOLLOWING`,
        trackingEvents: [],
        icon: undefined,
      },
      {
        name: t`BOOKMARKS`,
        urlPath: PROFILE_BOOKMARKS_ROUTE,
        isActive: false,
        uiKey: t`BOOKMARKS`,
        trackingEvents: [],
        icon: undefined,
      },
      {
        name: t`HISTORY_PURCHASES_TITLE`,
        urlPath: PROFILE_PURCHASES_ROUTE,
        isActive: false,
        uiKey: t`HISTORY_PURCHASES_TITLE`,
        trackingEvents: [],
        icon: undefined,
      },
      {
        name: t`ACCOUNT`,
        urlPath: PROFILE_ACCOUNT_ROUTE,
        isActive: false,
        uiKey: t`ACCOUNT`,
        trackingEvents: [],
        icon: undefined,
      },
      {
        name: t`SETTINGS`,
        urlPath: PROFILE_SETTINGS_ROUTE,
        isActive: false,
        uiKey: t`SETTINGS`,
        trackingEvents: [],
        icon: undefined,
      },
    ]
      .flat()
      .map((item) => {
        if (item.name === activeTabName) {
          return {
            name: item.name,
            isActive: true,
            urlPath: "",
            uiKey: item.name,
            trackingEvents: [],
            icon: undefined,
          };
        } else {
          return item;
        }
      });

    return tabs;
  }, [activeTabName, t]);
}
